import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "services/interceptor/Interceptor";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import FormSection from "../../formSection/formSection";
import localization from "assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ButtonWithIcon from "components/sales/buttons/buttonWithIcon/buttonWithIcon";
import { handleValidateObj } from "constants/objValues/objvalues";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import Inventory from "components/sales/inventory/inventory";
import { DatePickerInput } from "rc-datepicker";
import { Button, FormGroup } from "react-bootstrap";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { imageUploadUrlPublic } from "services/redux/fileUpload/action";
import * as moment from "moment";
import ModalPop from "../../modal/modal";
import s from "./addAdvance.module.css";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Config from "services/config/config";
import { Toast } from "bootstrap";
import { showToast } from "services/utils/networks/network";
import AppNotifications from "components/sales/appNotifications/appNotifications";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const AdvancePayment = ({
  showAdvancePopup,
  onClosePopup = () => { },
  imageUploadUrlPublic,
  businessId,
  invoiceId,
  contractId,
  siteNumber,
  businessName,
  contractType,
  isEdit = false,
  rowData = {},
  isView = false,
}) => {
  const [inputList, setInputList] = useState([
    {
      installation_amt: isEdit ? rowData?.installation_amount : "",
      cartage_amt: isEdit ? rowData?.cartage_amt : "",
      rental_charge: isEdit ? rowData?.rental_amount : "0",
      tag_charge: isEdit ? rowData?.tag_amount : "",
      payment_mode: isEdit ? rowData?.payment_mode : "",
      reference_number: isEdit ? rowData?.payment_reference : "",
      tds_check: isEdit ? (rowData?.tds === 0 ? "No" : "Yes") : "",
      tds_amt: isEdit ? rowData?.tds : "",
      remark: isEdit ? rowData?.remarks : isView ? rowData?.finance_remarks : '',
      payment_photo: "",
      adv_payment_date: isEdit ? rowData?.transaction_date : "",
      status: isEdit ? rowData?.status : "",
      bank: isEdit ? rowData?.bank : "",
      trans_amount: isEdit ? rowData?.amount : "",
      capex_charge:  isEdit ? rowData?.capex_amount : "0",
    },
  ]);
  const [payData, setPayData] = useState();
  const [isTarget, setIsTarget] = useState("");
  const [isFocus1, setIsFous1] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  // handle input change
  const handleInputChange = (e, index) => {
    console.log(e);
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      const { name, value } = e.target;
      const list = [...inputList];
      list[index][name] = value;
      setInputList(list);
    } else {
      return;
    }
  };
  const handleDateChange = (e, index, name) => {
    const current_datetime = moment(e).format("YYYY-MM-DD");
    const list = [...inputList];
    list[index][name] = current_datetime;
    setInputList(list);
  };
  const handledropDownChange = (e, index, name) => {
    // console.log(e);

    const list = [...inputList];
    if(!e){
      list[index][name] = '';
    }else{
      const { value, id } = e;
      list[index][name] = id;
    }
    setInputList(list);
  };

  const handleConstInput = (e, index, name) => {
    // console.log(e);
    const list = [...inputList];
    list[index][name] = e;
    setInputList(list);
  };

  const handleRemoveAll = () => {
    setIsTarget(0);
    setInputList([
      {
        installation_amt: "",
        cartage_amt:"",
        rental_charge: "",
        tag_charge: "",
        payment_mode: "",
        capex_charge: "",
        reference_number: "",
        tds_check: "",
        tds_amt: "",
        remark: "",
        payment_photo: "",
        adv_payment_date: "",
        status: "",
        trans_amount: "",
      },
    ]);
  };

  async function submit() {
    if (Number(inputList[0].trans_amount) !== (Number(inputList[0].installation_amt) +
      Number(inputList[0].rental_charge) +
      Number(inputList[0].capex_charge) +
      Number(inputList[0].tag_charge) +
      Number(inputList[0].cartage_amt))) {
      toast.error('Total amount must be equal to transaction amount')
    } else {
      try {
        setIsLoading(true);
        let url;
        if (isEdit) {
          url = Config.preSalesList.updateAdvanceRequest;
        } else {
          url = Config.preSalesList.addAdvance;
        }
        const payload = {
          request_id: isEdit ? rowData?.request_id : undefined,
          business_id: businessId,
          invoice_id: invoiceId,
          contract_id: contractId,
          site_number: siteNumber,
          payment_mode: inputList[0].payment_mode,
          amount: inputList[0].trans_amount,
          installation_amt: inputList[0].installation_amt,
          cartage_amt: inputList[0].cartage_amt,
          rental_charge: contractType !== 'CAPEX' ? inputList[0].rental_charge : undefined,
          capex_charge: contractType === 'CAPEX' ? inputList[0].capex_charge : undefined,
          tag_charge: inputList[0].tag_charge,
          transaction_date: inputList[0].adv_payment_date,
          bank_name: inputList[0].bank,
          tds_check: inputList[0].tds_check,
          tds_amt: inputList[0].tds_amt,
          payment_photo: inputList[0].payment_photo,
          reference_number: inputList[0].reference_number,
          status: inputList[0].status,
          remark: inputList[0].remark,
        };

        const { data } = await axios.post(url, payload);
        onClosePopup();
        toast.success('Add advance request submitted successfully')
        handleRemoveAll();
        setIsLoading(false);
      } catch {
        setIsLoading(false);
        toast.error('Something went wrong, Please try again')
      }
    }
  }

  const advancePayment = () => {
    return (
      <div className={s.root}>
        {inputList.map((x, i) => {
          return (
            <div>
              <div>
                <h4>Business Name: {businessName}</h4>
                <h4>Site Number: {siteNumber}</h4>
              </div>
              <div className={s.parallel_fields}>
                <DropDownInput
                  label={localization.paymentMode}
                  disabled={isView}
                  data={[
                    { id: "Cash", name: "Cash" },
                    { id: "Cheque", name: "Cheque" },
                    { id: "NEFT", name: "NEFT" },
                    { id: "IMPS", name: "IMPS" },
                    { id: "RTGS", name: "RTGS" },
                    { id: "UPI", name: "UPI" },
                    { id: "NACH", name: "NACH" },
                    { id: "PDC_CHEQUE", name: "PDC_CHEQUE" },
                  ]}
                  required
                  errorMsg={localization.paymentMode}
                  value={isEdit || isView ? rowData?.payment_mode : ''}
                  getIdValue={(val) => {
                    setPayData({
                      ...payData,
                      payment_mode: val.id,
                    });
                    handledropDownChange(val, i, "payment_mode");
                    handledropDownChange({id: null, value: ""},i,'status')
                  }}
                  // onChange={e => handleInputChange(e, i)}

                  isStarRequired={true}
                />

                <ConstantInput
                  label={localization.transAmount}
                  type="number"
                  disabled={isView}
                  required
                  value={isEdit || isView ? rowData?.amount : ''}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      trans_amount: val,
                    });
                    handleConstInput(val, i, "trans_amount");
                  }}
                  isStarRequired={true}
                />
              </div>
              <div className={s.parallel_fields}>
                <ConstantInput
                  label={localization.referenceNumber}
                  disabled={isView}
                  required
                  value={isEdit || isView ? rowData?.payment_reference : ''}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      reference_number: val,
                    });
                    handleConstInput(val, i, "reference_number");
                  }}
                  isStarRequired={true}
                />

                <FormGroup
                  className={`date custom_date_picker ${isFocus1 ? "active-date" : ""
                    }`}
                >
                  <label>
                    {localization.transactionDate}
                    <span className="label-star" style={{ color: "red" }}>
                      {" "}
                      *{" "}
                    </span>
                  </label>
                  <DatePickerInput
                    // onChange={handleDateChange1}
                    onChange={(e) => handleDateChange(e, i, "adv_payment_date")}
                    // onShow={() => setIsFous1(true)}
                    autoClose
                    disabled={isView}
                    defaultValue={isEdit || isView ? rowData?.transaction_date : ''}
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    // minDate={new Date()}
                    required
                    format="DD-MM-YYYY"
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                  />
                  {!isFocus1 && (
                    <label className="error date_error">
                      {localization.transactionDate}
                    </label>
                  )}
                </FormGroup>
              </div>
              <div className={s.parallel_fields}>
                <DropDownInput
                  label={localization.status}
                  data={
                    x.payment_mode == "Cash" || x.payment_mode == "Cheque"
                      ? [
                        {
                          id: "DEPOSITED IN BANK",
                          name: "Deposited in Bank",
                        },
                        {
                          id: "COLLECTED FROM CLIENT",
                          name: "Collected from Client",
                        },
                        {
                          id: "DEPOSITED TO FINANCE",
                          name: "Deposited to Finance",
                        },
                      ]
                      : [
                        {
                          id: "ONLINE TRANSACTION BY CLIENT",
                          name: "Online Transaction by Client",
                        },
                      ]
                  }
                  required
                  value={isEdit || isView ? rowData?.status : ''}
                  controlledValue={inputList[0].status}
                  errorMsg={localization.paymentMode}
                  getIdValue={(val) => {
                    setPayData({
                      ...payData,
                      status: val.id,
                    });
                    handledropDownChange(val, i, "status");
                  }}
                  // onChange={e => handleInputChange(e, i)}
                  disabled={x.payment_mode === "" || isView}
                  isStarRequired={true}
                />
                <DropDownInput
                  label="Select Bank"
                  disabled={isView}
                  data={[
                    {
                      id: "HDFC",
                      name: "HDFC",
                    },
                    {
                      id: "IDFC",
                      name: "IDFC",
                    },
                    {
                      id: "ICICI",
                      name: "ICICI",
                    },
                    {
                      id: "IDBI",
                      name: "IDBI",
                    },
                    {
                      id: "STANDARD_CHARTERED",
                      name: "STANDARD_CHARTERED",
                    },
                  ]}
                  required
                  value={isEdit || isView ? rowData?.bank : ''}
                  errorMsg={localization.paymentMode}
                  getIdValue={(val) => {
                    setPayData({
                      ...payData,
                      bank: val.id,
                    });
                    handledropDownChange(val, i, "bank");
                  }}
                  // onChange={e => handleInputChange(e, i)}
                  isStarRequired={true}
                />
              </div>

              <lable>
                {" "}
                <h4>Purpose of Payment</h4>
              </lable>
              <div className={s.field_combo}>
                <ConstantInput
                  label="Installation Amount"
                  disabled={isView}
                  type="number"
                  value={isEdit || isView ? rowData?.installation_amount : ''}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      installation_amt: val,
                    });
                    handleConstInput(val, i, "installation_amt");
                  }}
                  required={true}
                  isStarRequired={true}
                />
                <ConstantInput
                  label="Cartage Amount"
                  disabled={isView}
                  type="number"
                  value={isEdit || isView ? rowData?.cartage_amt : ''}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      cartage_amt: val,
                    });
                    handleConstInput(val, i, "cartage_amt");
                  }}
                  required={true}
                  isStarRequired={true}
                />
                <ConstantInput
                  label="Tag Amount"
                  disabled={isView}
                  type="number"
                  value={isEdit || isView ? rowData?.tag_amount : ''}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      tag_charge: val,
                    });
                    handleConstInput(val, i, "tag_charge");
                  }}
                  required={true}
                  isStarRequired={true}
                />
                {contractType !== 'CAPEX' ? <ConstantInput
                  label="Rental Amount"
                  disabled={isView}
                  type="number"
                  value={isEdit || isView ? rowData?.rental_amount : ''}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      rental_charge: val,
                    });
                    handleConstInput(val, i, "rental_charge");
                  }}
                  required={true}
                  isStarRequired={true}
                /> : <ConstantInput
                  label="Capex Amount"
                  disabled={isView}
                  type="number"
                  value={isEdit || isView ? rowData?.capex_amount : ''}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      capex_charge: val,
                    });
                    handleConstInput(val, i, "capex_charge");
                  }}
                  required={true}
                  isStarRequired={true}
                />} 
                <ConstantInput
                  type="text"
                  disabled
                  value={'Total Amount:   ' + 
                    (Number(x.installation_amt) +
                    Number(x.rental_charge) +
                    Number(x.capex_charge) +
                    Number(x.tag_charge) + 
                    Number(x.cartage_amt)).toString()
                  }
                />
              </div>
              <br />
              <div className={s.field_combo}>
                <DropDownInput
                  label={localization.tdsAmount}
                  data={[
                    { id: "Yes", name: "Yes" },
                    { id: "No", name: "No" },
                  ]}
                  required
                  disabled={isView}
                  value={isEdit || isView ? (rowData?.tds === 0 ? "No" : "Yes") : ''}
                  errorMsg={localization.tdsAmount}
                  getIdValue={(val) => {
                    setPayData({
                      ...payData,
                      tds_check: val.id,
                    });
                    handledropDownChange(val, i, "tds_check");
                  }}
                  // onChange={e => handleInputChange(e, i)}

                  isStarRequired={true}
                />
                {x.tds_check && x.tds_check == "Yes" && (
                  <ConstantInput
                    label={localization.tdsAmount}
                    type="number"
                    value={isEdit || isView ? rowData?.tds : ''}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        tds_amt: val,
                      });
                      handleConstInput(val, i, "tds_amt");
                    }}
                  />
                )}
              </div>
              <div className={s.parallel_fields}>
                <div className={s.parallel_fields}>
                  <ConstantInput
                    label='User Remark'
                    value={rowData?.remarks || ''}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />
                  {isView && <ConstantInput
                    label='Finance Remark'
                    value={rowData?.finance_remark || ''}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />}
                </div>
                <div>
                  {!isView && <FileUpload
                    id={"uploadAdvPay" + i}
                    multiple
                    accept="image/*"
                    documentUploadUrl={imageUploadUrlPublic}
                    required
                    onChange={(val) => {
                      // setPayData({ ...payData, payment_photo: val.toString() })
                      handleConstInput(val.toString(), i, "payment_photo");
                    }}
                  >
                    <span className="btn btn-transparent">
                      {localization.uploadPaymentPhotos}
                    </span>
                  </FileUpload>}
                </div>
              </div>
              <div className={s.parallel_fields}>
                  {isView && <ConstantInput
                    label='Transaction Id'
                    value={rowData?.bank_transaction_id || ''}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />}
                  {isView && <ConstantInput
                    label='ERP Voucher Number'
                    value={rowData?.erp_voucher_number || ''}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />}
                </div>
              {!isView && <>
              <hr style={{ marginTop: "24px" }} />
              <div className={s.button_box}>
                <div className={s.button}>
                  <Button onClick={() => submit()} disabled={
                    isLoading ||
                    x.payment_mode === '' ||
                    x.trans_amount === '' ||
                    x.reference_number === '' ||
                    x.transaction_date === '' ||
                    x.status === '' ||
                    x.bank === '' ||
                    x.tds_check === '' ||
                    (x.tds_check === 'Yes' && x.tds_amt === '') ||
                    x.installation_amt === '' ||
                    x.other_amount === '' ||
                    x.rental_charge === '' ||
                    x.tag_charge === '' || 
                    x.payment_photo === '' ||
                    isView
                  }>{isEdit ? 'Update' :'Submit'}</Button>
                </div>
              </div>
              </>}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <ModalPop
        title={isEdit ? "Edit Advance Request" : isView ? "View Advance Request" : "Add Advance"}
        show={showAdvancePopup}
        handleModalHide={() => {onClosePopup(); handleRemoveAll()}}
      >
        <Fragment>
          <FormSection>{advancePayment()}</FormSection>
        </Fragment>
      </ModalPop>
    </>
  );
};
AdvancePayment.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      imageUploadUrlPublic,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AdvancePayment);
